import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import { Btn, H3, P } from "../../../AbstractElements";
import { useSuperAdmin } from "../../../hooks/useSuperAdmin";
import { LoginAccount } from "../../../utils/Constant";
import CommonLogo from "./CommonLogo";

export const Login: React.FC = () => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, isLoading, error } = useSuperAdmin();

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (email.trim() === "" || password.trim() === "") {
      toast.error("Please enter both email and password.");
      return;
    }

    await login({ email, password });
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xl="12" className="p-0">
          <div className="login-card login-dark">
            <div className="login-main">
              <div>
                <CommonLogo alignLogo="text-center" />
              </div>
              <Form className="theme-form" onSubmit={handleLogin}>
                <H3>{LoginAccount}</H3>
                <P>{"Login to the Dashboard"}</P>
                <FormGroup>
                  <Input
                    type="email"
                    required
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <div className="form-input position-relative">
                    <Input
                      type={show ? "text" : "password"}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <div className="show-hide" onClick={() => setShow(!show)}>
                      <span className="show"> </span>
                    </div>
                  </div>
                </FormGroup>
                <FormGroup className="mb-0 form-sub-title">
                  <div className="text-end mt-3">
                    <Btn
                      color="primary"
                      block
                      className="w-100"
                      disabled={isLoading}
                    >
                      {isLoading ? <Spinner size="sm" /> : "Login"}
                    </Btn>
                  </div>
                </FormGroup>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
